import { ErrorBoundary } from '@awais4123/fillify-design-library';
import { JaneAvatar } from 'components/BKJJaneAvatar';
import { Flex } from 'components/Flex';
import { css } from 'styled-components';
import {
  Jane as ShiftJane,
  JaneName,
  JaneFacility,
  ShiftJaneWrapper,
} from 'components/ShiftModal/src/components/ShiftJane/ShiftJane.styled';

import { Jane } from 'types/graphql';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';

export function TimeOffJane({
  avatarUrls,
  firstName,
  lastName,
  communityName,
  pendingSignup,
}: Jane) {
  return (
    <ErrorBoundary componentName="TimeOffJane" showLogo={!WhiteLabelAccessor.isWhiteLabelled()}>
      <ShiftJaneWrapper>
        <ShiftJane justifyContent="space-between" alignItems="center" width="100%">
          <Flex alignItems="center">
            <JaneAvatar
              url={avatarUrls.small}
              status={'in_progress'}
              css={css`
                margin-right: 13px;
              `}
              size={30}
              pendingSignup={pendingSignup}
            />
            <Flex flexDirection="column">
              <JaneName>{`${firstName} ${lastName}`}</JaneName>
              <JaneFacility>{communityName}</JaneFacility>
            </Flex>
          </Flex>
        </ShiftJane>
      </ShiftJaneWrapper>
    </ErrorBoundary>
  );
}
